var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"title":_vm.params.displayName},domProps:{"innerHTML":_vm._s(_vm.headerHrml)}})
}
var staticRenderFns = []

export { render, staticRenderFns }